module.exports = __webpack_public_path__ + "static/img/18.b37d2180.png";